import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetRoutesRequest, GetRoutesResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'pick-route.component.html',
  styleUrls: ['./pick-route.component.scss']
})
export class PickRouteComponent implements OnInit {

  routeResponse: GetRoutesResponse | null = null;
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadRouteList();
  }

  loadRouteList() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      const request: GetRoutesRequest = {
        clientId: startNewVoucherData.clientId
      };
      if (startNewVoucherData.regionId !== undefined && startNewVoucherData.regionId !== null) {
        request.regionId = startNewVoucherData.regionId;
      }
      this.courierService.getRoute(request).subscribe((response: GetRoutesResponse) => {
        this.routeResponse = response;
        this.loading = false;
      }, error => {
        console.error('Error fetching routes:', error);
        this.loading = false;
      });
    } else {
      this.router.navigate(['/pick-car']);
    }
  }

  continueNextStep(routeId: number | undefined) {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.routeId = routeId;
      this.router.navigate(['/checklist']);
    }
  }

  navigateToPickClient() {
    this.router.navigate(['/pick-client']);
  }
}